import { Label } from "@fluentui/react";
import React from "react";
import RequestByDropdown from "../elements/requestByDropdown/RequestByDropdown";
import { ITeamTypeSettingProps } from "../../../../../interfaces/teamTypeSettings/ITeamTypeSettingProps";
import ApprovalByDropdown from "../elements/approvalByDropdown/ApprovalByDropdown";

export default function DeleteTeam(props: ITeamTypeSettingProps) {
	return <>
		<Label>Kan ingediend worden door</Label>

		<RequestByDropdown
			selectedKeys={props.values.settings.deleteTeam.requestBy}
			onChange={(option) => props.updateRequestOrApprovalBySettings("deleteTeam", "requestBy", option)}
		/>

		<ApprovalByDropdown
			selectedKeys={props.values.settings.deleteTeam.approvalBy}
			onChange={(option) => props.updateRequestOrApprovalBySettings("deleteTeam", "approvalBy", option)}
		/>
	</>;
}